module.exports = __webpack_public_path__ + "static/media/YM58_7.c29db697.jpg";